export function megbytesToBytes(megabytes: number) {
  return megabytes * 1024 * 1024;
}
